import { UseFormReturn } from "react-hook-form";

import DefaultInput from "../../../../../../common/components/default_form_input";
import PasswordInput from "../../../../../../common/components/password_input";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * ConfigureLoginStepTwo
 */

type Props = {
  hookForm: UseFormReturn<any>,
  onSubmit?: () => void,
};

export const ConfigureLoginStepTwo = ({
  hookForm,
  onSubmit,
}: Props) => {
  return (
    <form onSubmit={onSubmit}>
      <div className="text-black dark:text-white w-full mt-8 flex flex-col gap-4">
        <h1 className="text-3xl font-semibold">
          Informe o seu login do sistema antigo
        </h1>
        <p className="text-sm font-regular">
          Faça login com as mesmas credenciais que você utiliza no sistema antigo.
        </p>
      </div>
      <div className="w-full flex gap-4 flex-col items-center justify-center mt-16">
        <div className="w-full">
          <h1 className="text-black dark:text-white font-semibold">
            Informe os dados abaixo:
          </h1>
        </div>

        <DefaultInput
          name='loginAntigo'
          label="Login antigo"
          reactHookForm={hookForm}
        />

        <PasswordInput
          label="Senha atual"
          error={hookForm.formState.errors.oldPassword !== undefined}
          helperText={hookForm.formState.errors.oldPassword?.message as string}
          reactHookForm={hookForm.register('oldPassword')}
        />

        <DefaultInput
          name='loginNovo'
          label="Novo login(email)"
          reactHookForm={hookForm}
        />

        <PasswordInput
          label="Nova senha"
          error={hookForm.formState.errors.newPassword !== undefined}
          helperText={hookForm.formState.errors.newPassword?.message as string}
          reactHookForm={hookForm.register('newPassword')}
        />

        <PasswordInput
          label="Confirmar nova senha"
          error={hookForm.formState.errors.newPasswordConf !== undefined}
          helperText={hookForm.formState.errors.newPasswordConf?.message as string}
          reactHookForm={hookForm.register('newPasswordConf')}
        />

      </div>
      <div className="w-full flex justify-end my-10">
        <div className="w-44">
          <PrimaryButton type="submit">Próximo</PrimaryButton>
        </div>
      </div>
    </form>
  );
};